module.exports = __webpack_public_path__ + "img/luxemburg-fall.6e3fba72.png";